var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-points-reward-detail',{staticClass:"pt-points-reward-detail__page"})}
var staticRenderFns = []

export { render, staticRenderFns }